import { router } from "@/main";
import { Route } from "@/paths";
import { textFontFamily } from "@/theme";
import { Group, Select, Stack, Tabs } from "@mantine/core";
import { Fragment } from "react";
import { generatePath, useParams } from "react-router-dom";
import { css } from "vite-plugin-inline-css-modules";
import { panelManifest } from "../panelManifest";

export const HeaderTabs = () => {
  const navigate = router.navigate;
  const { modelId = "" } = useParams();

  const currentTab =
    panelManifest.find((tab) =>
      window.location.pathname.includes("/" + tab.path),
    ) || panelManifest[0];

  const currentTabPath = currentTab.path;

  const MobileNavigation = (
    <Group hiddenFrom="lg" gap="xs" align="center">
      <Select
        size="md"
        width={180}
        maw={180}
        data={panelManifest.map((tab) => ({
          value: tab.path,
          label: tab.label,
        }))}
        defaultValue={currentTabPath}
        onChange={(modelTabId) =>
          navigate(
            generatePath(Route.ModelTab, {
              modelTabId,
              modelId,
            }),
          )
        }
        allowDeselect={false}
        maxDropdownHeight={999}
        styles={{
          input: {
            fontFamily: textFontFamily,
            lineHeight: 1,
            height: 35,
            minHeight: 35,
          },
          // wrapper: {
          //   height: 30,
          // },
          // dropdown: {
          //   height: 500,
          // },
        }}
        renderOption={({ option }) => {
          const tab = panelManifest.find((tab) => tab.path === option.value);
          const Icon = tab?.icon;
          return (
            <Group flex="1" gap="xs">
              {Icon && <Icon />}
              {option.label}
            </Group>
          );
        }}
      />
    </Group>
  );

  const DesktopNavigation = (
    <Stack
      h={"100%"}
      justify="flex-end"
      visibleFrom="lg"
      flex={1}
      style={{
        overflow: "hidden",
      }}
    >
      <Tabs
        classNames={{ tab: styles.tab }}
        color="infomatic.3"
        keepMounted={true}
        value={currentTabPath}
        onChange={(modelTabId) =>
          navigate(
            generatePath(Route.ModelTab, {
              modelTabId,
              modelId,
            }),
          )
        }
      >
        <Tabs.List style={{ flexWrap: "nowrap" }}>
          {panelManifest.map((tab) => (
            <Fragment key={tab.path}>
              <Tabs.Tab
                value={tab.path}
                leftSection={tab.icon({ size: 18 })}
                fw={600}
                px={"md"}
                children={tab.label}
                {...tab.tabsTabProps}
                visibleFrom="xl"
              />

              <Tabs.Tab
                value={tab.path}
                fw={600}
                px={"calc((100vw - 300px) / 68)"}
                children={tab.label}
                hiddenFrom="xl"
                {...tab.tabsTabProps}
              />
            </Fragment>
          ))}
        </Tabs.List>
      </Tabs>
    </Stack>
  );

  return (
    <>
      {DesktopNavigation}
      {MobileNavigation}
    </>
  );
};

const styles = css`
  .tab {
    border-bottom: 4px solid var(--mantine-color-blue-3);

    &[data-active] {
      border-radius: 0;
      background-color: var(--mantine-color-accent-0);
      border-bottom: 4px solid var(--mantine-color-accent-3);
    }
  }
`;
